export const scheduleFields = ['unit', 'name', 'role', 'email', 'telephone', 'premisesAddress', 'correspondenceAddress'];
const normal = (text) => text.trim().toLowerCase().replace(/\s+/g, ' ');
const unitKey = (text) => normal(text).replace(/^(?:flat|unit|apartment|property|premises)\s+/, '');
/** A deterministic review projection; it never creates identities or relationships. */
export function previewSchedule(sheets, mapping, locations, page = 1) {
    const sheet = sheets[mapping.sheet];
    if (!sheet || !Number.isInteger(mapping.sheet) || !Number.isInteger(mapping.header) || mapping.header < 0 || mapping.header > 24 || !sheet.rows[mapping.header])
        throw Error('Choose a valid sheet and header row.');
    const columns = Object.entries(mapping.columns);
    const width = Math.max(0, ...sheet.rows.map(row => row.length));
    if (mapping.columns.unit === undefined || !columns.length || columns.some(([key, column]) => !scheduleFields.includes(key) || !Number.isInteger(column) || column < 0 || column >= width) || new Set(columns.map(([, column]) => column)).size !== columns.length)
        throw Error('Map the unit column and use each source column only once.');
    if (!Number.isInteger(page) || page < 1)
        throw Error('Choose a valid page.');
    const rows = [], units = new Map(), people = new Map();
    for (let index = mapping.header + 1; index < sheet.rows.length; index++) {
        const source = sheet.rows[index];
        // Unmapped non-empty rows still appear: no row silently disappears from review.
        if (!source.some(cell => cell.trim()))
            continue;
        const values = Object.fromEntries(columns.map(([key, column]) => [key, source[column]?.trim() ?? '']));
        const row = { sourceRow: index + 1, values, issues: [] };
        rows.push(row);
        const key = unitKey(values.unit ?? ''), person = normal(values.name ?? '');
        if (key)
            units.set(key, (units.get(key) ?? 0) + 1);
        if (person)
            people.set(person, (people.get(person) ?? 0) + 1);
        if (!key)
            row.issues.push('Unit reference missing');
        else {
            const matches = locations.filter(location => !location.provisional && (unitKey(location.name) === key || unitKey(location.code) === key));
            if (matches.length === 1)
                row.match = { id: matches[0].id, name: matches[0].name };
            else
                row.issues.push(matches.length ? 'More than one canonical unit matches' : 'Unit identity needs reconciliation');
        }
        if (!person)
            row.issues.push('No contact name supplied');
        // Source wording is shown verbatim. A filename or name is never relationship authority.
        if (!values.role)
            row.issues.push('Relationship not supplied');
    }
    for (const row of rows) {
        if ((units.get(unitKey(row.values.unit ?? '')) ?? 0) > 1)
            row.issues.push('Repeated unit reference — review all source rows');
        if ((people.get(normal(row.values.name ?? '')) ?? 0) > 1)
            row.issues.push('Repeated contact name — identity is not established by name alone');
    }
    return { mapping, sheetName: sheet.name, total: rows.length, page, pageSize: 20, issueRows: rows.filter(row => row.issues.length).length, matchedRows: rows.filter(row => row.match).length, distinctUnits: units.size, rows: rows.slice((page - 1) * 20, page * 20) };
}
//# sourceMappingURL=schedule-preview.js.map